package com.cybersoftsolution.cybersoftsolutionweb.components.buttons

import androidx.compose.runtime.Composable
import com.cybersoftsolution.cybersoftsolutionweb.models.Theme
import com.cybersoftsolution.cybersoftsolutionweb.styles.PrimaryButtonStyle
import com.cybersoftsolution.cybersoftsolutionweb.utils.IdConst.primaryButtonId
import com.varabyte.kobweb.compose.css.Cursor
import com.varabyte.kobweb.compose.foundation.layout.Box
import com.varabyte.kobweb.compose.ui.Alignment
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.modifiers.backgroundColor
import com.varabyte.kobweb.compose.ui.modifiers.borderRadius
import com.varabyte.kobweb.compose.ui.modifiers.color
import com.varabyte.kobweb.compose.ui.modifiers.cursor
import com.varabyte.kobweb.compose.ui.modifiers.fillMaxSize
import com.varabyte.kobweb.compose.ui.modifiers.id
import com.varabyte.kobweb.compose.ui.modifiers.margin
import com.varabyte.kobweb.compose.ui.modifiers.onClick
import com.varabyte.kobweb.compose.ui.modifiers.position
import com.varabyte.kobweb.compose.ui.modifiers.size
import com.varabyte.kobweb.compose.ui.modifiers.zIndex
import com.varabyte.kobweb.compose.ui.styleModifier
import com.varabyte.kobweb.silk.components.icons.fa.FaPlus
import com.varabyte.kobweb.silk.components.icons.fa.IconSize
import com.varabyte.kobweb.silk.style.breakpoint.Breakpoint
import com.varabyte.kobweb.silk.style.toModifier
import com.varabyte.kobweb.silk.theme.breakpoint.rememberBreakpoint
import org.jetbrains.compose.web.css.Position
import org.jetbrains.compose.web.css.px

@Composable
fun AddButton(onCLick: () -> Unit = {} ){

    val breakpoint = rememberBreakpoint()

    Box(
        contentAlignment = Alignment.BottomEnd,
        modifier = Modifier
            .fillMaxSize()
            .position(Position.Fixed)
            .styleModifier {
                property("pointer-events", "none")
            }
            .zIndex(10)

    ) {
        Box(
            contentAlignment = Alignment.Center,
            modifier = PrimaryButtonStyle.toModifier()
                .id(primaryButtonId)
                .margin(
                    right =  if (breakpoint >= Breakpoint.MD) 40.px else 20.px,
                    bottom =  if (breakpoint >= Breakpoint.MD) 40.px else 20.px
                )
                .size(
                    if (breakpoint >= Breakpoint.MD) 80.px else 50.px
                )
                .cursor(Cursor.Pointer)
                .borderRadius(15.px)
                .onClick{ onCLick() }
                .backgroundColor(Theme.PrimaryButton.rgb)
                .styleModifier {
                    property("pointer-events", "auto")
                }

        ) {
            FaPlus(
                modifier = Modifier.color(Theme.Black.rgb),
                size = IconSize.XL
            )

        }

    }
}